import React from 'react'
import { connect } from 'react-redux';
import Row from '../../../../common/grid/Row.js';
import Col from '../../../../common/grid/Col.js';
import Button from '../../../../common/button/Button.js';
import ImageUpload from "../../../../common/image/ImageUpload.js";
import CheckboxContainer from '../../../../common/checkbox/CheckboxContainer.js';
import { fetchRoles } from '../../../../actions/role.js';
import { createUser } from '../../../../actions/user.js';
import { setErrors, clearErrors } from '../../../../actions/error.js';

import { withFormik, Form, Field } from 'formik';
import * as Yup from 'yup';

import './AddUser.css';

class NewAddUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            profile_photo: '',
            range: 0
        }
    }

    componentDidMount() {
        this.props.fetchRoles();
    }

    renderRoles = () => {
        if (!this.props.roles) {
          return null;
        } else {
          return (<CheckboxContainer
            title='Select Roles'
            name='roles'
            checkboxData={this.props.roles.map(r => ({ value: r.id, display_name: r.display_name }))}
            checkAgainst={this.state.roles.map(r => ({ value: r }))}
            onCheckboxChange={this.onCheckboxChange}
          />);
        }
      }

      onCheckboxChange = (value, name) => {
        const arr = this.state[name];
    
        // check if state[name] has value
        if (arr.includes(value)) {
          arr.splice(arr.indexOf(value), 1);
          this.setState({ [name]: arr });
        } else {
          this.setState({ [name]: arr.concat(value) });
        }
      }

      onPhotoUpload = ({ file, range }) => {
        this.setState({ profile_photo: file, range });
      }
    
    render(){
     const { values, errors, touched } = this.props;
     values.roles = this.state.roles;
     values.profile_photo = this.state.profile_photo;
     values.range = this.state.range;
     
        return (
            <Form className="add-user">
                <h2>Add User</h2>
                <Row _gap-32 _no-grow-first>
                    <Col _bottom-8>
                        <ImageUpload uploadText='Upload' apply={this.onPhotoUpload} />
                    </Col>
                    <Col _bottom-16>
                        <Row mb50 _right-16 _warp>
                            <div className={`input-field ${touched.firstname && !errors.firstname && 'succes'} ${touched.firstname && errors.firstname && 'error'}`}>
                                <Field type="text" name="firstname"/>
                                <label>First Name</label>
                                { touched.firstname && errors.firstname && <div className="field-error">{errors.firstname}</div> }
                            </div>
                            <div className={`input-field ${touched.lastname && !errors.lastname &&'succes'} ${touched.lastname && errors.lastname && 'error'}`}>
                                <Field type="text" name="lastname"/>
                                <label>Last Name</label>
                                { touched.lastname && errors.lastname && <div className="field-error">{errors.lastname}</div> }
                            </div>
                        </Row>
                        <Row mb50 _bottom-16 _warp>
                            <div className={`input-field ${touched.phone && !errors.phone && 'succes'} ${touched.phone && errors.phone && 'error'}`}>
                                <Field type="number" name="phone"/>
                                <label>Phone</label>
                                { touched.phone && errors.phone && <div className="field-error">{errors.phone}</div> }
                            </div>
                        </Row>
                        <Row mb50 _bottom-16 _warp>
                            <div className={`input-field ${touched.email && values.email && 'succes'} ${touched.email && errors.email && 'error'}`}>
                                <Field type="email" name="email"/>
                                <label>Email</label>
                                { touched.email && errors.email && <div className="field-error">{errors.email}</div> }
                            </div>
                        </Row>
                        <Row mb50 _bottom-16 _right-16 _warp>
                            <div className={`input-field ${touched.password && values.password && 'succes'} ${touched.password && errors.password && 'error'}`}>
                                <Field type="password" name="password"/>
                                <label>Password</label>
                                { touched.password && errors.password && <div className="field-error">{errors.password}</div> }
                            </div>
                            <div className={`input-field ${touched.password_confirm && values.password_confirm && 'succes'} ${touched.password_confirm && errors.password_confirm && 'error'}`}>
                                <Field type="password" name="password_confirm"/>
                                <label>Confirm Password</label>
                                { touched.password_confirm && errors.password_confirm && <div className="field-error">{errors.password_confirm}</div> }
                            </div>
                        </Row>
                        <Row _right-16 _warp>
                            {this.renderRoles()}
                        </Row>
                         <Row _space-between>
                            <Button type="submit" className="btn-green btn-square">
                                Save
                            </Button>
                        </Row>
                    </Col>
                </Row>

            </Form>
        )
    }
}

const FormikApp = withFormik({
    mapPropsToValues({ firstname, lastname, phone, email, password, password_confirm, roles, profile_photo, range }) {
        return {
            firstname: firstname || '',
            lastname: lastname || '',
            phone: phone || '',
            email: email || '',
            password: password || '',
            password_confirm: password_confirm || '',
            roles,
            profile_photo,
            range
        }
    },

    validationSchema: Yup.object().shape({
        firstname: Yup.string().required('First Name is Required'),
        lastname: Yup.string().required('Last Name is Required'),
        phone: Yup.number().required('Phone is Required'),
        email: Yup.string().required('Email is Required').email('Email is Invalid'),
        password: Yup.string().required('Password is Required'),
        password_confirm: Yup.string().required('Confirm Password is Required')
    }),

    handleSubmit(values, {props}) {
		const user = {
            company_id: props.company_id,
            first_name: values.firstname,
            last_name: values.lastname,
            phone: values.phone,
            email: values.email,
            password: values.password,
            password_confirmation: values.password_confirm,
            roles: values.roles,
            profile_photo: values.profile_photo,
            range: values.range
          }

          props.createUser(user);
	}
})(NewAddUser);

const mapStateToProps = (state) => {
    return {
      roles: state.role,
      company_id: state.auth.currentUser.company_id,
      number: state.user.number
    }
  }
  
  const mapDispatchToProps = {
    addErrors: (errors) => dispatch => dispatch(setErrors(errors)),
    emptyErrors: () => dispatch => dispatch(clearErrors()),
    fetchRoles,
    createUser
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(FormikApp);


// WEBPACK FOOTER //
// ./src/components/main/user-management/add/newAddUser.js